import React from 'react';
import './BookingPage.css';

import { BookingForm, PageTitle } from '../../../components';


const BookingPage = () => (

  <>

    {/* Page Title */}
    <PageTitle title={'Reservation'} page={'Reservation'} />

    <section className="custom-form booking-form">
      <div className="box-container">
        <div className="content">
          <BookingForm formType="booking-page" />
        </div>
      </div>
    </section>

  </>

);

export default BookingPage;